<script setup lang="ts">

    export interface Props {
        href ?: string,
        target ?: string
    }

    const props = withDefaults(defineProps<Props>(), {
        href: '#',
        target: '_blank'
    });

</script>

<template>
    <a class="news-component-item-close-button"
        :href 
        :target 
    >
        <slot>
            
        </slot>
    </a>
</template>

<style>
    .news-component-item-close-button {

        font-family: var(--bmeFontFamily);
        font-size: var(--bmeBody2FontSize);
        line-height: var(--bmeBody2LineHeight);
        font-weight: var(--bmeBody2FontWeight);

        border-radius: 2rem;
        height: var(--bmeBody2LineHeight);
        width: var(--bmeBody2LineHeight);
        padding: 0.5rem;
        border: 1px solid var(--bmePrimary);
        text-decoration: none;
        display: inline-grid;
        align-items: center;
        justify-content: center;
        
        background-color: var(--bmeWhite);
        color: var(--bmePrimary);

        &:hover {
            background-color: var(--bmeLightGrey100);
        }

        @media screen and (max-width: 1280px) { /* TODO Confirm Breakpoint */
            background-color: var(--bmePrimary);
            color: var(--bmeWhite);
            &:hover {
                background-color: var(--bmePrimaryHover);
            }
        }
        
    }
</style>